import { patchOutlookSpace } from '../service';
import { timeStreamProjectUpdated } from '../index';
import type { ProjectId, PatchOutlookSpace } from 'owa-timestream-types';

export default async function updateTimeStreamProject(
    projectId: ProjectId,
    updates: PatchOutlookSpace,
    preventSearch?: boolean
) {
    await patchOutlookSpace(projectId, updates);
    timeStreamProjectUpdated(projectId, updates, preventSearch);
}
